import { apolloClient } from '~/apollo-client';

import {
  Flex_SendInstantAlertMutation,
  Flex_SendInstantAlertMutationVariables,
} from '~/typings/graphql';

import { SEND_INSTANT_ALERT } from './send-instant-alert.queries';

export type SendInstantAlertParams = {
  utilityAccountId: number;
  event: string;
  properties?: string;
};

export type SendInstantAlertResponse = {
  success: boolean;
  message?: string;
};

export const sendInstantAlert = async (
  params: SendInstantAlertParams,
): Promise<SendInstantAlertResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_SendInstantAlertMutation,
    Flex_SendInstantAlertMutationVariables
  >({
    mutation: SEND_INSTANT_ALERT,
    variables: {
      input: {
        utilityAccountId: params.utilityAccountId,
        event: params.event,
        properties: params.properties,
      },
    },
  });

  return {
    success: !!data?.sendInstantAlert.success,
    message: data?.sendInstantAlert.message || undefined,
  };
};
